import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import CurrentUser from "logic/users/CurrentUser";
import UserNotification from "util/UserNotification";
const viewsUrl = qualifyUrl("/views");
const viewsIdUrl = (id) => qualifyUrl(`/views/${id}`);
export const getView = (viewId) => fetch("GET", viewsIdUrl(viewId));
export const deleteView = (view) => fetch("DELETE", viewsIdUrl(view.id)).catch((error) => {
  UserNotification.error(
    i18n.t("views_notifications.delete_view_failed", { ns: "search", title: view.title, error }),
    i18n.t("views_notifications.delete_view_failed_title", { ns: "search" })
  );
});
export const createView = (view, entityShare, clonedFrom) => {
  const url = clonedFrom ? viewsIdUrl(clonedFrom) : viewsUrl;
  const promise = fetch("POST", url, JSON.stringify({ entity: view.toJSON(), share_request: entityShare }));
  return promise.then((response) => {
    CurrentUser.reload();
    return response;
  });
};
export const updateView = (view, entityShare) => fetch("PUT", viewsIdUrl(view.id), JSON.stringify({ entity: view.toJSON(), share_request: entityShare }));
